export default __webpack_public_path__ + "static/media/gallery-wip-flash-suppressor_07.cddecb43.jpg";